import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=6d3c7b84&scoped=true&"
var script = {}
import style0 from "./PlusIcon.vue?vue&type=style&index=0&id=6d3c7b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c7b84",
  null
  
)

export default component.exports